export default __webpack_public_path__ + "static/media/m_foodieBooster03.bc52f3e6.png";